export default "__VITE_ASSET__Xlb8V6MG__"